/*@flow*/
import styled from '@emotion/styled';

export default (styled.select(`
  border: none;
  -webkit-appearance: none;
  outline: 0;
  border-radius: 0;
  width: 100%;

  background-color: white;
  background-image: url("https://image.flaticon.com/icons/svg/60/60781.svg");
  background-position: 92% 50%;
  background-repeat: no-repeat;
  background-size: 10px;
  cursor: pointer;
`): any);
